module.exports = __webpack_public_path__ + "static/media/dentira_logo.fe6cdb98.svg";